import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkText } from "uitk-react-text";
import { PackageConfig } from "stores/wizard/config";

export interface ValuePropSubtitleProps {
  config: PackageConfig;
}

export const ValuePropSubtitle: React.FC<ValuePropSubtitleProps> = ({ config }) => {
  const { formatText } = useLocalization();

  return (
    <UitkText size={300} spacing="six">
      {formatText(config.pillsLabelKey)}
    </UitkText>
  );
};
